import { useTranslation } from 'react-i18next'

import NewModal from '../root/modals/NewModal'
import HelpDeskTicketForm from './HelpDeskTicketForm'

const CreateTicketModal = ({ isOpen, setIsOpen, onCreated }) => {
  const { t } = useTranslation()

  return (
    <NewModal
      title={t('support.new_ticket_modal_title')}
      page="w-xl"
      showModal={isOpen}
      setShowModal={setIsOpen}
      contentClassName="text-left !p-0"
    >
      {isOpen ? (
        <div className="p-4">
          <HelpDeskTicketForm
            onCancel={() => setIsOpen(false)}
            onSuccess={(ticket) => {
              setIsOpen(false)
              onCreated?.(ticket)
            }}
          />
        </div>
      ) : null}
    </NewModal>
  )
}

export default CreateTicketModal
